import { FixtureModule } from '@/modules/fantasy/fixture';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute('/dashboard/fantasy/fixture/')({
  validateSearch: searchSchema,
  component: FixturePage,
});

function FixturePage() {
  return <FixtureModule />;
}
